export var EventAction;
(function (EventAction) {
    EventAction["ShowModal"] = "showModal";
    EventAction["Url"] = "url";
})(EventAction || (EventAction = {}));
